import { render, staticRenderFns } from "./ProfilesInvoiceProductTable.vue?vue&type=template&id=7a8cb701&scoped=true"
import script from "./ProfilesInvoiceProductTable.vue?vue&type=script&lang=js"
export * from "./ProfilesInvoiceProductTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8cb701",
  null
  
)

export default component.exports